module.exports = __webpack_public_path__ + "static/media/Phone-HairColor-Mockup.1f6b3932.png";